import { Card, CardBody, Col } from "reactstrap";
import { GrooveBorderTitle } from "../../../Constants/Constants";
import { DottedBorderSubData } from "../../../Data/UiKits/HelperClasses";
import { dynamicNumber } from "../../../Utils";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const GrooveBorder = () => {
  return (
    <Col xl="3">
      <Card>
        <CommonCardHeader title={GrooveBorderTitle} span={DottedBorderSubData} />
        <CardBody>
          <div className="helper-common-box helper-p-wrapper">
            {dynamicNumber(3).map((item, index) => (
              <div key={index} className={`border-common-box border-s-groove b-width-${item}`}>
                b-width-{item}
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default GrooveBorder;
